import { CareersPageContent } from './shipsticks.page.content'

const content: CareersPageContent = {
  hero: {
    backgroundImage: '/images/shipskis/careers-hero.jpg',
    title: 'Career Opportunities',
    subtitle: "Join the team that's changing the way the world travels.",
  },
  mainContent: {
    title: 'Why choose ShipSkis?',
    subtitle: 'We travel light, but think big.',
    paragraphs: [
      'At ShipSkis, we believe getting to the ski resort should be just as \
        easy as being there. That’s why we’ve made it our mission to simplify \
        how skiers and boarders get their gear to and from home - no stress, no baggage claim.',

      'Based in Palm Beach Gardens, Florida, our team is made up of \
        problem-solvers, innovators, and big thinkers. We value collaboration, \
        curiosity, and creative solutions that make travel easier.',

      'Explore our current openings below. Don’t see the perfect fit? We’re \
        always looking for great people to join our team. Send your resume to \
        careers@shipskis.com.',
    ],
  },
  benefits: {
    title: 'We invest in you.',
    subtitle: 'Because great work deserves great benefits.',
    paragraphs: [
      'Along with a competitive salary, health coverage (including dental and vision), ' +
        '401(k) matching, and paid time off, ShipSkis offers parental leave, flexible ' +
        'work options (including hybrid and remote), fun team outings, and employee ' +
        'discounts so you, too, can travel easier.',
    ],
  },
  reasonsToWork: [],
}

export default content
